module.exports = __webpack_public_path__ + "static/media/column-swap-step1.45dec39a.svg";